export default __webpack_public_path__ + "static/media/car5.2c86be06.png";